module.exports = __webpack_public_path__ + "img/calendar-21.00a17113.svg";